export default function($) {
  $("#submit-review-link").on('click', function() {
    $('li.reviews_tab a').trigger('click');
  });
}
